import proxy from "api/proxy";

const model = "hotel.folio";

const addNightView = {
  start: {
    label: "add_start",
    msg: "hotel.folio.add_night.msg_start",
    buttons: [{ name: "ok", handleClick: onAcceptAdd }],
  },
  success: {
    label: "add_success",
    msg: "hotel.folio.add_night.msg_success",
  },
  error: {
    key: "add_error",
  },
};

async function onAcceptAdd(store) {
  let next;
  let msgError;
  const method = "add_night";
  const args = [{ folio_id: store.recordId, nights: 1 }];
  const { error } = await proxy.methodCall({ model, method, args });
  if (error) {
    next = "error";
    msgError = error.error;
  } else {
    next = "success";
  }
  return { next, msgError };
}

export { addNightView };
